import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SharedModule } from '@modules/shared.module';
import { ButtonDeleteComponent } from '../button-delete/button-delete.component';
import { ButtonCancelDialogComponent } from '../button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '../button-close-dialog/button-close-dialog.component';
import { ButtonCancelComponent } from '../button-cancel/button-cancel.component';
import { MatDividerModule } from '@angular/material/divider';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { ButtonDeleteAndCancelComponent } from "../button-delete-and-cancel/button-delete-and-cancel.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dialog-delete',
  templateUrl: './dialog-delete.component.html',
  styleUrls: ['./dialog-delete.component.css'],
  imports: [CommonModule, ButtonDeleteComponent, ButtonCancelComponent, ButtonCloseDialogComponent, MatDividerModule, CdkTrapFocus, ButtonDeleteAndCancelComponent, MatDialogModule],
  standalone: true

})
export class DialogDeleteComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogDeleteComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.data.title = this.data.title?.trim() || 'Acción realizada :: <strong>Eliminar</strong>'
    this.data.message = this.data.message?.trim() || '¿Está seguro que desea eliminar el registro seleccionado?'
    this.data.id = this.data.item.id

    if (!this.data.descripcion) {
      this.data.descripcion = '';
    }
  }

  doAction() {
    this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.id });
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }


}
